import React, {useEffect, useRef, useState} from "react";
import {
    FlyerPageSpotDto,
    ItemsListMenuDto,
    PromoDto,
    PromoItemsDto, SaleTypeDto,
    SelectPageForTabsDto, SellingUnitDto
} from "../../../../../../../dtos";
import {Draggable, DraggableStateSnapshot, DraggingStyle, NotDraggingStyle} from "react-beautiful-dnd";
import styles from "./unlinkedPromoOrItem.module.scss";
import {
    PromotionItem
} from "../../../../leftMenu/LeftMenuContent/LeftMenuContentElement/LeftMenuPromotionItem/LeftMenuPromotionItem";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";
import {AsyncImageWithLoader} from "../../../../../../../com/imageWithLoader/imageWithLoader";
import {useDispatch} from "react-redux";
import {
    addPromosForUnlinkedPromotionsMenu, attachItemsToFlyer,
    attachPromoToFrame,
    changeQualificationStatusForItems,
    changeQualificationStatusForPromos,
    deleteItemsFromFlyer,
    deletePromosFromFlyer,
} from "../../../../../../../store/actionCreators/promotionsItemsCreators";
import {getSettingsForPopup} from "../../../../../pages/getSetttingsForPopup";
import StatusPopup, {StatusPopupType} from "../../../../../../../com/statusPopup/StatusPopup";
import {ReactComponent as PromotionIcon} from "../../../../../../../assets/promos&items/promotion_icon.svg";
import {
    ReactComponent as ToggleCollapseItemsInPromotion
} from "../../../../../../../assets/promos&items/toggle_collapse_items_in_promotion_icon.svg";
import {ReactComponent as MenuOnHover} from "../../../../../../../assets/promos&items/menu_on_hover.svg";
import {
    MenuForPromotion
} from "../../../../leftMenu/LeftMenuContent/LeftMenuContentElement/MenuForPromotions/menuForPromotions";
// import Button from '@material-ui/core/Button';
import {MENU_LIST_PROMOTIONS_ITEMS} from "../../../../../../../globals/Contants";
import {ReactComponent as DragIcon} from "../../../../../../../assets/promos&items/drag_icon.svg";
import {
    MenuForItems
} from "../../../../leftMenu/LeftMenuContent/LeftMenuContentElement/LeftMenuPromotionItem/MenuForItems/menuForItem";
import {ReactComponent as ImageWithError} from "../../../../../../../assets/promos&items/image_error.svg";
import {
    CreateEditItemModal
} from "../../../../leftMenu/LeftMenuContent/LeftMenuContentElement/LeftMenuPromotionItem/CreateEditItemModal/CreateEditItemModal";
import {getPromoSaleTypeCaptions} from "../../../../../../../globals/PromoSaleTypeCaptionGenerator";
import {
    PromotionDetailsModalPopup
} from "../../../../leftMenu/LeftMenuContent/LeftMenuContentElement/PromotionDetailsModalPopup/PromotionDetailsModalPopup";
import {
    QualificationForPromoComponent
} from "../../../../../../com/QualificationForPromoComponent/QualificationForPromoComponent";
import {
    QualificationForItemComponent
} from "../../../../../../com/QualificationForItemComponent/QualificationForItemComponent";
import {Button} from "@mui/material";

interface Props {
    promo?: PromoDto;
    item?: PromoItemsDto;
    tabName: string;
    index?: number;
    onChangeSelectedPromos?: (promo: PromoDto, event: React.MouseEvent<HTMLElement>, index: number) => void;
    onChangeSelectedItems?: (item: PromoItemsDto, e: React.MouseEvent<HTMLElement>) => void;
    isSelected: boolean;
    targetItems?: PromoItemsDto[];
    isHebrew: boolean;
    isHide?: boolean;
}

function getStyle(style: DraggingStyle | NotDraggingStyle | undefined, snapshot: DraggableStateSnapshot) {
    if (!snapshot.isDragging) return {};
    if (!snapshot.isDropAnimating) {
        return style;
    }

    return {
        ...style,
        // cannot be 0, but make it super tiny
        transitionDuration: `0.001s`
    };
}

export const UnlinkPromoOrItem = React.memo((props: Props) => {
    const dispatch = useDispatch();
    const anchorRef = useRef(null);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    const saleTypes = useTypedSelector((state) => state.saleTypes.saleTypesForSpecificFlyer);

    const [isHoverOnUnlinkPromoAndItem, changeStatusForUnlinkPromoAndItem] = useState<boolean>(false);
    const [isOpenPromotionOrItemMenu, setStatusForPromotionOrItemMenu] = useState(false);
    const [caption, setCaption] = useState<string>('');
    const [isShowItems, setStatusForShowItem] = useState<boolean>(false);
    const [qualificationLevel, setQualificationLevel] = useState<number | undefined>(props.promo?.qualificationLevel);
    // const [userName, setUserName] = useState<string>('');
    const sellingUnitsForFlyer = useTypedSelector((state) => state.sellingUnits.sellingUnitsForFlyer);


    const prevOpenPromotionMenu = useRef(isOpenPromotionOrItemMenu);


    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const [frames, setFrames] = useState<FlyerPageSpotDto[]>([]);

    const [isModalPopup, changeModalStatus] = useState(false);

    const [isSelect, setSelect] = useState<boolean>(false);


    const [isOpenItemModal, setOpenItemModal] = useState<boolean>(false);
    const [isNewItem, setStatusForNewOrNotForItem] = useState<boolean>(false);
    const [imageSrc, setImageSrc] = useState<string | null>(props.item ? props.item.fpiImage! : '');
    const [itemQualification, setItemQualificationStatus] = useState<number | undefined>(props.item?.qualificationLevel);
    const [selectedItem, setSelectedItem] = useState<PromoItemsDto>({});


    const [isOpenPromotionModalPopup, openPromotionModalPopup] = useState<boolean>(false);
    const [isNewPromotion, setStatusForNewOrNotForPromotion] = useState<boolean>(false);

    const [isShowCaptionForPromotion, toggleShowCaptionForPromotion] = useState<boolean>(false);
    const isDisableDraggable = flyerDetailsState.flyFstRec.fstCaption === "Published";


    useEffect(() => {
        if (promotionsItemsState.type === 'ATTACH_ITEMS_TO_FLYER_SUCCESS' && !promotionsItemsState.targetFrameId) {
            const newState = [...promotionsItemsState.unlinkPromos].map((promoState: PromoDto) => {
                if (promoState.flrRecId === props.promo?.flrRecId) {
                    promoState.flyerPromoItems = [...promoState.flyerPromoItems!].filter((item: PromoItemsDto) => {
                        const isIterableItemShouldBeUnlink = promotionsItemsState.itemsIds.find((id: number) => id === item.fpiRecId);
                        if (!isIterableItemShouldBeUnlink) {
                            return item;
                        }
                    });
                }
                return promoState;
            });
            dispatch(addPromosForUnlinkedPromotionsMenu(newState, true))
        }
    }, [promotionsItemsState.type]);

    useEffect(() => {
        if (props.item) {
            setImageSrc(props.item.fpiImage!);
        }
    }, [props.item])

    // useEffect(() => {
    //     let userDtoStr = localStorage.getItem('userDto')
    //
    //     if (userDtoStr) {
    //         let userDto: UserDto = JSON.parse(userDtoStr);
    //
    //         if (userDto.firstName && userDto.lastName) {
    //             setUserName(`${userDto.firstName} ${userDto.lastName}`);
    //         } else {
    //             setUserName('you');
    //         }
    //     }
    // }, [])


    useEffect(() => {
        if (props.promo) {
            const selectedSaleType = saleTypes.find((saleType: SaleTypeDto) => saleType.satCode === props.promo!.flrSatCode);
            const selectedSellingUnit = sellingUnitsForFlyer?.find((sellingUnit: SellingUnitDto) => {
                if (sellingUnit.id === props.promo?.flrSeuRecId) {
                    return sellingUnit;
                }
            })
            if (selectedSaleType) {
                setCaption(getPromoSaleTypeCaptions(selectedSaleType, flyerDetailsState.flyLacRec.lacCurrencySymbol!, selectedSellingUnit, props.promo!));
            }

            //flyer type
            const isFlyerWithPrices = flyerDetailsState.flyFltRec.fltCode !== 3;
            if (isFlyerWithPrices
                || (
                    !isFlyerWithPrices
                    && (
                        props.promo?.flrSatCode === 20
                        || props.promo?.flrSatCode === 21
                        || props.promo?.flrSatCode === 50
                        || props.promo?.flrSatCode === 51
                        || props.promo?.flrSatCode === 1
                        || props.promo?.flrSatCode === 30
                        || props.promo?.flrSatCode === 41
                        || props.promo?.flrSatCode === 50
                        || props.promo?.flrSatCode === 80
                    )
                )
            ) {
                toggleShowCaptionForPromotion(true);
            } else {
                toggleShowCaptionForPromotion(false);
            }

        }
    }, [props.promo])

    useEffect(() => {
        setQualificationLevel(props.promo?.qualificationLevel);
    }, [props.promo?.qualificationLevel]);

    useEffect(() => {
        setItemQualificationStatus(props.item?.qualificationLevel);
    }, [props.item?.qualificationLevel]);

    useEffect(() => {
        setSelect(props.isSelected);
    }, [props.isSelected])

    useEffect(() => {
        setFrames(flyerDetailsState.flyerPages[selectedPageState.pageNo === 0 ? 0 : selectedPageState.pageNo - 1]?.flyerPageSpots!);
    }, [flyerDetailsState, selectedPageState])

    const onClickFrame = (e: any) => {
        // e.preventDefault();
        // hideMenu();
        document?.getSelection()!.removeAllRanges();
        if (!e.target.className.toString().includes('optionForPreventEvent')) {
            if (props.tabName !== "Promotions") {
                props.onChangeSelectedItems!(props.item!, e);

                // if (isSelect && e.target.classList.value !== 'MuiButton-label') {
                //     props.onChangeSelectedItems!(props.item!, e);
                // } else if (!isSelect && e.target.classList.value !== 'MuiButton-label') {
                //     props.onChangeSelectedItems!(props.item!, e);
                // } else if (!isSelect && e.target.classList.value === 'MuiButton-label') {
                //     props.onChangeSelectedItems!(props.item!, e);
                // }
            } else {
                props.onChangeSelectedPromos!(props.promo!, e, props.index!)
            }
        }
    }

    const changeQualificationForPromo = () => {
        if (props.promo) {
            if (qualificationLevel !== 0) {
                dispatch(changeQualificationStatusForPromos([props.promo.flrRecId!], flyerDetailsState?.flyLacRec?.lacCode!, qualificationLevel === 1 ? 2 : 1, flyerDetailsState, true, selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo))
                setQualificationLevel(qualificationLevel === 1 ? 2 : 1);
            }
        }
    }

    const changeQualificationStatus = () => {
        if (itemQualification !== 0) {
            dispatch(changeQualificationStatusForItems([props.item!.fpiRecId!], flyerDetailsState?.flyLacRec?.lacCode!, itemQualification === 1 ? 2 : 1, flyerDetailsState, true, selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo, false))
            setItemQualificationStatus(itemQualification === 1 ? 2 : 1);
        }
    }


    const onDelete = (isDeleteWithItem?: boolean) => {
        if (props.tabName === "Promotions") {
            // const newPromotionsState = promotionsItemsState.unlinkPromos.filter((promo:PromoDto) => promo.flrRecId !== props.promo?.flrRecId);
            // removeAllUnlinkedPromos
            // const ids = flyerDetailsState.flyerPromos!.map((key: PromoDto) => key.flrRecId!);
            // dispatch(deletePromosFromFlyer(ids, isDeleteWithItem, flyerDetailsState.flyRecId!));
            //
            dispatch(deletePromosFromFlyer([props.promo!.flrRecId!], isDeleteWithItem!, flyerDetailsState.flyRecId!));
            changeModalStatus(false);
        } else {
            // props.onChangeSelectedItems!(props.item!)
            const targetItemsIds = [...props.targetItems!].map((item: PromoItemsDto) => item.fpiRecId!);

            dispatch(deleteItemsFromFlyer(targetItemsIds, flyerDetailsState.flyRecId!))
            // const newItemsState = promotionsItemsState.unlinkItems.filter((item:PromoItemsDto) => item.fpiRecId !== props.item?.fpiRecId);
            // dispatch(deleteItemsFromUnlinkedPromotionsItemsMenu(newItemsState));
        }
    }

    const onLinkToFirstEmptyFrame = () => {
        const firstEmptyFrames = frames.find((frame: FlyerPageSpotDto) => frame.flyerPromos?.length === 0);
        if (firstEmptyFrames) {
            dispatch(attachPromoToFrame(props.promo!.flrRecId!, firstEmptyFrames!.fpsRecId!, false, flyerDetailsState.flyLacRec.lacCode, true));
        }
    }

    const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        setStatusForPromotionOrItemMenu((prevOpen) => !prevOpen);
    };


    const onMouseEnterPromo = () => {
        changeStatusForUnlinkPromoAndItem(true);
    }

    const onMouseLeavePromo = () => {
        changeStatusForUnlinkPromoAndItem(false);
        setStatusForPromotionOrItemMenu(false);
    }

    const showHideItems = () => {
        setStatusForShowItem(!isShowItems);
    }


    const onAddNew = () => {
        setStatusForNewOrNotForItem(true);
        setOpenItemModal(true);
    }
    const onEdit = () => {
        setStatusForNewOrNotForItem(false);
        setOpenItemModal(true);
    }
    const onEditItemFromPromotion = (promoItem: PromoItemsDto) => {
        setStatusForNewOrNotForItem(false);
        setImageSrc(promoItem.fpiImage ? promoItem.fpiImage : '');
        setSelectedItem(promoItem);
        setStatusForNewOrNotForItem(false);
        setOpenItemModal(true);
    }

    const createNewPromotion = () => {
        setStatusForNewOrNotForPromotion(true);
        openPromotionModalPopup(true);
    }

    const editPromotion = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setStatusForNewOrNotForPromotion(false);
        openPromotionModalPopup(true);
    }

    const unlinkAllItemFromPromoSelectedPromo = () => {
        console.log(props.promo);
        if (props.promo?.flyerPromoItems) {
            const promoItemsIds: number[] = props.promo?.flyerPromoItems?.map((item: PromoItemsDto) => item.fpiRecId!);
            dispatch(attachItemsToFlyer(flyerDetailsState.flyRecId, promoItemsIds, false, props.promo))
        }
    }


    const clickMenuData: ItemsListMenuDto = {
        setOpen: setStatusForPromotionOrItemMenu,
        prevOpen: prevOpenPromotionMenu,
        open: isOpenPromotionOrItemMenu,
        anchorRef: anchorRef,
        menuList: MENU_LIST_PROMOTIONS_ITEMS
    }

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: props.tabName === 'Promotions' ? 'deletePromosFromFlyer' : 'deleteItemsFromFlyer',
        confirmOnClick: {
            deletePromosItemsFromFlyer: onDelete
        }
    };

    let settingsForPopup = getSettingsForPopup(settings);

    let department: string;

    if (props.promo && props.promo.flyerPromoItems && props.promo.flyerPromoItems.length && props.promo.flyerPromoItems[0].fpiDeptName) {
        department = props.promo.flyerPromoItems[0].fpiDeptName;
    } else {
        department = '';
    }


    if (props.tabName === "Promotions") {
        return (
            <>
                <div onClick={onClickFrame} className={styles.unlink_promo_main_wrapper}>
                    <div className={`${styles.frame_promo_wrap}`}>
                        <Draggable
                            // disableInteractiveElementBlocking={true}
                            // isDragDisabled={true}
                            isDragDisabled={isDisableDraggable}
                            draggableId={`${props.promo?.flrRecId!.toString()}${props.promo?.flrCode!.toString()}`}
                            index={props.promo?.flrRecId!}>
                            {({innerRef, draggableProps, dragHandleProps}, snapshot) => (
                                <>

                                    <div
                                        className={`${styles.unlink_promo_wrapper}`}
                                        ref={innerRef}
                                        {...draggableProps}
                                        style={getStyle(draggableProps.style, snapshot)}

                                    >
                                        <div
                                            className={`${styles.unlink_promo} ${props.isHebrew ? styles.is_hebrew : ''} ${isSelect ? styles.selectedPromo : ''}`}>
                                            <div
                                                className={`${styles.promo_wrapper} ${!props.promo?.flyerPromoItems?.length ? styles.align_center : ''}`}>
                                                <div className={styles.promo_info_wrapper}>
                                                    {
                                                        department !== '' &&
                                                        <div className={styles.frame_info_wrapper}>
                                                            <div className={styles.frame_info}>
                                                                <div className={styles.promos_category}>
                                                                    {/*{'Department'}*/}
                                                                    {department}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div
                                                        className={`${styles.promotion_info_container} ${isHoverOnUnlinkPromoAndItem ? styles.hover : ''}`}
                                                        onMouseEnter={onMouseEnterPromo}
                                                        onMouseLeave={onMouseLeavePromo}>
                                                        <div className={styles.promotion_content}>
                                                            <div className={styles.promotion_info}>
                                                                <div className={styles.promotion_icon}>
                                                                    <PromotionIcon/>
                                                                </div>
                                                                <div className={styles.promotion_details}>

                                                                    {
                                                                        isShowCaptionForPromotion &&
                                                                        <div className={styles.promotion_caption_name}
                                                                             title={caption}>
                                                                            <span>{caption}</span>
                                                                        </div>
                                                                    }
                                                                    <div
                                                                        className={`${styles.promotion_items_wrapper} ${promotionsItemsState.isQualified ? styles.with_quality : ''}`}>
                                                                        <div
                                                                            className={styles.promotion_items_caption}>
                                                                                <span>
                                                                                    {
                                                                                        props.promo!.flrCaption
                                                                                    }
                                                                                </span>

                                                                        </div>
                                                                        {/*<div*/}
                                                                        {/*    className={`${styles.toggle_collapse_icon_wrapper} ${isShowItems ? styles.is_open : ''}`}*/}
                                                                        {/*    onClick={showHideItems}>*/}
                                                                        {/*    <ToggleCollapseItemsInPromotion/>*/}
                                                                        {/*</div>*/}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={styles.promotion_right_part_wrapper}>
                                                                <div
                                                                    className={styles.promotion_code_group}
                                                                >
                                                                    <div
                                                                        className={`${styles.promotion_code} ${promotionsItemsState.isQualified ? styles.is_qualification_mode : ''}`}>
                                                                        Code: {props.promo?.flrCode}
                                                                    </div>
                                                                    {promotionsItemsState.isQualified &&
                                                                        <div className={styles.promo_qualification_icon}
                                                                             onClick={changeQualificationForPromo}>
                                                                            <QualificationForPromoComponent
                                                                                promo={props.promo!}
                                                                                caption={caption}
                                                                                editPromotion={editPromotion}
                                                                                promoQualification={qualificationLevel}
                                                                                isShowPromoCaption={isShowCaptionForPromotion}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </div>
                                                                {
                                                                    props.promo?.flyerPromoItems?.length! > 0 &&
                                                                    <div className={`${styles.arrow_wrapper}`}>
                                                                        <div
                                                                            className={`${styles.toggle_collapse_icon_wrapper} ${isShowItems ? styles.is_open : ''} ${promotionsItemsState.isQualified ? styles.arrow_with_margin : ''}`}
                                                                            onClick={showHideItems}>
                                                                            <ToggleCollapseItemsInPromotion/>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>

                                                        {isHoverOnUnlinkPromoAndItem &&
                                                            <>
                                                                <div
                                                                    className={styles.menu_for_promotion_and_items_wrapper}>
                                                                    <Button
                                                                        disableRipple={true}
                                                                        ref={anchorRef}
                                                                        aria-controls={isOpenPromotionOrItemMenu ? 'menu-list-grow' : undefined}
                                                                        aria-haspopup="true"
                                                                        onClick={handleToggle}
                                                                    >
                                                                        <MenuOnHover/>
                                                                    </Button>
                                                                    <MenuForPromotion
                                                                        list={clickMenuData}
                                                                        isUnlinkPromo={true}
                                                                        deleteUnlinkPromotionsFromFlyer={changeModalStatus}
                                                                        linkUnlinkPromotionToFirstEmptyFrame={onLinkToFirstEmptyFrame}
                                                                        editPromotion={editPromotion}
                                                                        createNewPromotion={createNewPromotion}
                                                                        unlinkAllItemFromPromoSelectedPromo={unlinkAllItemFromPromoSelectedPromo}
                                                                        infoForMenu={`menuForUnlinkedPromo`}
                                                                    />

                                                                </div>
                                                                {
                                                                    !isDisableDraggable &&
                                                                    <div
                                                                        className={styles.draggable_area}
                                                                        {...dragHandleProps}
                                                                        {...draggableProps}

                                                                    >
                                                                        <DragIcon/>
                                                                    </div>
                                                                }
                                                            </>

                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                            {
                                                props.promo?.flyerPromoItems?.length! > 0 && isShowItems &&
                                                <div className={styles.list_of_items}>
                                                    <ul>
                                                        {props.promo?.flyerPromoItems?.map((item: PromoItemsDto) => {
                                                            // let currentItem = promotionsItemsState.pages[selectedPageState.pageNo !== 0 ? selectedPageState.pageNo - 1 : selectedPageState.pageNo].items.filter((promoItem: PromoItemsDto) => {
                                                            //     return promoItem.fpiRecId === item.fpiRecId;
                                                            // });
                                                            // const currentItem = promotionsItemsState.items.filter((promoItem: PromoItemsDto) => {
                                                            //     return promoItem.fpiRecId === item.fpiRecId;
                                                            // });

                                                            return <PromotionItem
                                                                key={item.fpiRecId}
                                                                item={item}
                                                                // key={currentItem[0] ? currentItem[0].fpiRecId : item.fpiRecId}
                                                                // item={currentItem[0] ? currentItem[0] : item}
                                                                promo={props.promo}
                                                                isQualification={promotionsItemsState.isQualified}
                                                                unlinkAllItemFromPromoSelectedPromo={unlinkAllItemFromPromoSelectedPromo}
                                                                isUnlinkPromo={true}
                                                                onEditItem={onEditItemFromPromotion}
                                                            />
                                                        })}
                                                    </ul>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </>
                            )}
                        </Draggable>
                    </div>
                </div>
                {isModalPopup && <StatusPopup
                    settings={settingsForPopup}
                    type={StatusPopupType.INFO}
                    title={'INFO'}
                    subTitle={''}
                    messages={[settingsForPopup.messages]}
                    show={isModalPopup}
                    handleClose={() => changeModalStatus(false)}
                />
                }

                {
                    isOpenPromotionModalPopup &&
                    <PromotionDetailsModalPopup
                        isShow={isOpenPromotionModalPopup}
                        isNewPromotion={isNewPromotion}
                        promotionData={isNewPromotion ? {} : props.promo!}
                        openPromotionModalPopup={openPromotionModalPopup}
                        isHebrew={props.isHebrew}
                        currencySymbol={flyerDetailsState.flyLacRec.lacCurrencySymbol!}
                        // eventPromotionData={props.promo!}
                        isUnlinked={true}
                    />
                }
                {isOpenItemModal &&
                    <CreateEditItemModal
                        isShow={isOpenItemModal}
                        defaultContentForModal={isNewItem ? {} : selectedItem}
                        isNewItem={isNewItem}
                        setOpenItemModal={setOpenItemModal}
                        promo={props.promo ? props.promo : {}}
                        lang={flyerDetailsState?.flyLacRec?.lacCode!}
                        imageSrc={isNewItem ? '' : (imageSrc ? imageSrc : '')}
                    />}
            </>
        )
    } else {
        return (
            <div>
                <Draggable draggableId={`${props.item?.fpiRecId!.toString()}`}
                           index={Number(`${props.item?.fpiRecId!}`)}
                           isDragDisabled={isDisableDraggable}
                >
                    {({innerRef, draggableProps, dragHandleProps}, snapshot) => {
                        const shouldShowSelection: boolean = snapshot.isDragging && props.targetItems!.length > 1;
                        return (
                            <div
                                onClick={onClickFrame}
                                onContextMenu={onClickFrame}
                                className={
                                    `${styles.unlink_item_wrap} ${props.isHebrew ? styles.is_hebrew : ''} ${isSelect ? styles.selectedItem : ''} ${shouldShowSelection ? styles.dragging_item : ''} ${props.isHide ? styles.hide_item : ''} ${isHoverOnUnlinkPromoAndItem ? styles.on_hover_unlink_item : ''}`
                                }
                                ref={innerRef}
                                {...dragHandleProps}
                                {...draggableProps}
                                onMouseEnter={onMouseEnterPromo}
                                onMouseLeave={onMouseLeavePromo}
                                style={getStyle(draggableProps.style, snapshot)}
                            >
                                <div>
                                    <div className={styles.item_dept_wrapper}>
                                        <div className={styles.qualification_item_icon}
                                             onClick={changeQualificationStatus}>
                                            {promotionsItemsState.isQualified &&
                                                <QualificationForItemComponent
                                                    item={props.item!}
                                                    editItem={onEdit}
                                                    itemQualification={itemQualification}
                                                />
                                            }
                                        </div>

                                        {props.item?.fpiDeptName ?
                                            <div
                                                className={`${styles.filled_item_department} ${styles.item_department}`}>
                                                {props.item?.fpiDeptName}
                                            </div> :
                                            <div className={`${styles.item_department}`}>
                                                {props.item?.fpiDeptName}
                                            </div>
                                        }
                                    </div>
                                    <div className={styles.unlink_item_content}>
                                        <div className={styles.unlink_item_img_wrapper}>
                                            <AsyncImageWithLoader src={imageSrc ? imageSrc : ''}
                                                                  notUploadIcon={(<ImageWithError/>)}/>
                                        </div>
                                        <div className={styles.unlink_item_info_wrapper}>
                                            <div className={styles.unlink_item_caption}>
                                                {props.item?.fpiCaption}
                                            </div>
                                            {/*<div className={styles.unlink_item_price_wrapper}>*/}
                                            <div className={styles.unlink_item_price}>
                                                {flyerDetailsState.flyLacRec.lacCurrencySymbol} {props.item?.fpiRegularPrice ? props.item?.fpiRegularPrice?.toFixed(2) : '0.00'}
                                            </div>
                                            <div className={styles.unlink_item_sku}>
                                                {props.item?.fpiSku}
                                            </div>
                                            {/*</div>*/}
                                        </div>
                                        {isHoverOnUnlinkPromoAndItem &&
                                            <>
                                                <div
                                                    className={`${styles.menu_for_promotion_and_items_wrapper} ${styles.unlink_items_menu_area}`}>
                                                    <Button
                                                        disableRipple={true}
                                                        ref={anchorRef}
                                                        aria-controls={isOpenPromotionOrItemMenu ? 'menu-list-grow' : undefined}
                                                        aria-haspopup="true"
                                                        onClick={handleToggle}
                                                    >
                                                        <MenuOnHover/>
                                                    </Button>
                                                    <MenuForItems
                                                        list={clickMenuData}
                                                        isUnlinkItem={true}
                                                        deleteUnlinkItemsFromFlyer={changeModalStatus}
                                                        targetItemsLength={props.targetItems?.length}
                                                        onCreateNewItem={onAddNew}
                                                        onEditExistItem={onEdit}
                                                    />

                                                </div>
                                            </>

                                        }

                                        {shouldShowSelection ? (
                                            <div className={styles.selection_count}>{props.targetItems?.length}</div>
                                        ) : null}

                                    </div>
                                </div>
                            </div>
                        )
                    }}
                </Draggable>
                {
                    isModalPopup && <StatusPopup
                        settings={settingsForPopup}
                        type={StatusPopupType.INFO}
                        title={'INFO'}
                        subTitle={''}
                        messages={[settingsForPopup.messages]}
                        show={isModalPopup}
                        handleClose={() => changeModalStatus(false)}
                        targetItemsLength={props.targetItems?.length}
                    />
                }
                {isOpenItemModal &&
                    <CreateEditItemModal
                        isShow={isOpenItemModal}
                        defaultContentForModal={isNewItem ? {} : props.item!}
                        isNewItem={isNewItem}
                        setOpenItemModal={setOpenItemModal}
                        promo={props.promo ? props.promo : {}}
                        lang={flyerDetailsState?.flyLacRec?.lacCode!}
                        imageSrc={isNewItem ? '' : (imageSrc ? imageSrc : '')}
                    />}
            </div>
        )
    }
});